import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { UserLoggedInNavigatorNavigationProp } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

export type TodoCreateParamList = {
  Main: {
    categoryId: string;
    connectionId?: string;
    assignedToMeConnectionId?: string;
  };
  TodoCreateLinkProduct: {};
};

export type TodoCreateScreenProps<T extends keyof TodoCreateParamList> = {
  route: RouteProp<TodoCreateParamList, T>;
  navigation: CompositeNavigationProp<
    NativeStackNavigationProp<TodoCreateParamList, T>,
    UserLoggedInNavigatorNavigationProp<"TodoCreate">
  >;
};

export const TodoCreateNavigator =
  createNativeStackNavigator<TodoCreateParamList>();
